import React from 'react';
import { Card, Row, Col, Image, Typography, Button, Space } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

interface Product {
  image: string;
  name: string;
  item_id: string; // e.g., "商品ID: 683e6cfcf078780001fd417a"
  specifications: string; // e.g., "规格: --"
  purchase_price: number;
  purchase_price_range: string;
}

interface ProductDisplayCardProps {
  product: Product;
  onDelete: (productId: string) => void;
}

const ProductDisplayCard: React.FC<ProductDisplayCardProps> = ({
  product,
  onDelete,
}) => {
  return (
    <Card
      style={{ width: '100%', marginBottom: 16 }} // Adjust width and margin as needed
      bodyStyle={{ padding: 16 }}
    >
      <Row gutter={[16, 16]} wrap={false}>
        {/* Image Column */}
        <Col>
          <Image
            width={80} // Adjust as needed
            height={80} // Adjust as needed
            src={product.image || 'https://via.placeholder.com/80'} // Placeholder if no image
            preview={false}
            style={{ objectFit: 'cover', borderRadius: '4px' }}
          />
        </Col>

        {/* Product Info Column */}
        <Col flex="auto">
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Title
              level={5}
              style={{ margin: 0, fontWeight: 'normal' }}
              ellipsis={{ rows: 2, tooltip: product.name }}
            >
              {product.name}
            </Title>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {product.item_id}
            </Text>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {product.specifications}
            </Text>
          </Space>
        </Col>

        {/* Price Column */}
        <Col style={{ textAlign: 'right' }}>
          <Text
            style={{ color: '#ff4d4f', fontWeight: 'bold', fontSize: '16px' }}
          >
            {product.purchase_price_range ||
              '¥' + (product.purchase_price / 100)?.toFixed(2) ||
              '¥0.00'}
          </Text>
        </Col>
      </Row>

      {/* Action Buttons Row */}
      <Row justify="end" style={{ marginTop: 16 }}>
        <Space>
          <Button
            icon={<DeleteOutlined />}
            onClick={() => onDelete(product.item_id)}
            size="small"
          >
            删除
          </Button>
        </Space>
      </Row>
    </Card>
  );
};

export default ProductDisplayCard;

// Example Usage (you can put this in another file where you want to use the card):
/*
const MyPage = () => {
  const sampleProduct: Product = {
    id: '123',
    imageUrl: 'https://gw.alicdn.com/bao/uploaded/i2/O1CN01N0Z1z51Cj2Z0Z0Z_!!0-item_pic.jpg_200x200.jpg', // Replace with actual image
    name: '99新仙女用手机便宜好用',
    productIdText: '商品ID: 683e6cfcf078780001fd417a',
    specifications: '规格: --',
    price: '¥99.00',
  };

  const handleDelete = (productId: string) => {
    console.log('Delete product:', productId);
    // Add your delete logic here
  };

  const handleChangeSpecifications = (productId: string) => {
    console.log('Change specifications for product:', productId);
    // Add your logic to change specifications here
  };

  return (
    <div style={{ padding: 20, maxWidth: 500 }}>
      <ProductDisplayCard
        product={sampleProduct}
        onDelete={handleDelete}
        onChangeSpecifications={handleChangeSpecifications}
      />
    </div>
  );
};
*/
